export const MAX_UPLOAD_SIZE = 1048576;

